/*
configures the requirejs namespaces
returns an application constructor
usage:

require(["liferay"], function (loader) {
  loader.done(function (App) {
	App.create().done(function(app) {
		// do things with the app instance
	});
  });
});

*/

import globals = require("./globals");
import AppType = require("./app/app");
import Portal = require("portal-gis");

const baseUrl = `//${location.host}/o/rhythm-civics-gis-web/dist`;

type Callback = (A: AppType) => void;

/**
 * IE11 polyfills
 */
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty("remove")) {
      return;
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

let npm = (name) => ({
  name: name,
  location: `./${name}`,
  main: name,
});

class LiferayLoader {
  load(options: { view: Marionette.View<any>; services?: string; config?: Portal.MapApplicationElement }) {
    let callbacks = <Array<Callback>>[];

    let done = (cb: Callback) => {
      callbacks.push(cb);
      return; // void
    };

    requirejs.config({
      baseUrl: baseUrl,

      map: {
        "*": {
          openlayers: "ol",
          jquery: "plugins/global!$",
          underscore: "plugins/global!_",
          backbone: "plugins/global!Backbone",
          "backbone.marionette": "plugins/global!Backbone.Marionette",
        },
      },

      packages: [
        "main",
        {
          name: "proj4",
          location: "./proj4/dist",
          main: "proj4",
        },
        {
          name: "ol",
          location: "./ol",
          main: "ol",
        },
        {
          name: "ol-css",
          location: "./ol",
          main: "ol.css",
        },
        {
          name: "xstyle",
          location: "./xstyle",
        },
        {
          name: "jquery",
          location: "jquery/dist",
          main: "jquery",
        },
        npm("underscore"),
        npm("backbone"),
        {
          name: "backbone.marionette",
          location: npm("backbone.marionette/lib").location,
          main: "backbone.marionette",
        },
        {
          name: "app",
          location: `${baseUrl}/rhythm-gis/built`,
        },
      ],

      waitSeconds: 0, // ol.debug fails to load sometimes

      callback: () => {
        // overwrite the global services endoint before other modules attempt to access it
        if (options.services) {
          globals.services = options.services;
        }
        if(options.view.options.layerList){
          globals.layerList = options.view.options.layerList;
        }
        // console.log("requiring app/liferay-runner");
        requirejs(["app/liferay-runner"], (Loader: { run: Function }) => {
          Loader.run(options).then((app) => {
            done = (cb: Callback) => cb(app);
            callbacks.forEach((cb) => cb(app));
            callbacks = [];
          });
        });
      },
    });

    return done;
  }
}

function go(options: any) {
  let loader = new LiferayLoader();
  // if we are dealing with a server-side configuration, blot out the parent information
  if (options && options.config && options.config.id) options.config.parentId = "";
  return loader.load(options);
}

go["about"] = `

This is the runtime loader for the Rhythm Civics map.  It configures the requirejs namespaces and returns a promise to the application constructor.

Usage Example:

	require(["liferay"], function (loader) {
		loader.done(function (App) {
			App.create().done(function(app) {
				// do things with the app instance
			});
		});
	});

`;

export = go;
